import React from 'react';
import { useRouteMeta } from '../hooks/useRouteMeta';
import { useT } from '../i18n/useT';
import RouteHero from '../components/RouteHero';
import SecuritySection from '../components/SecuritySection';
import ConnectivityGuide from '../components/ConnectivityGuide';
import TaglineBanner from '../components/TaglineBanner';
import BackToOverview from '../components/BackToOverview';

const SecurityPage: React.FC = () => {
  useRouteMeta('security');
  const { r } = useT();
  return (
    <>
      <RouteHero
        eyebrow={r.routes.security.eyebrow}
        title={r.routes.security.heroTitle}
        subtitle={r.routes.security.heroSubtitle}
      />
      <SecuritySection />
      <ConnectivityGuide />
      <TaglineBanner />
      <BackToOverview />
    </>
  );
};

export default SecurityPage;
